import { useState, useEffect } from 'react';

export default function BookSplash() {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
        }, 450);

        return () => clearTimeout(timer);
    }, []);

    if (!visible) return null;

    return (
        <div id="bookSplash" className="splash-screen" role="status" aria-label="Loading library">
            {/* Ambient background particles */}
            <div className="particles" aria-hidden="true">
                {[...Array(8)].map((_, i) => (
                    <div key={i} className={`particle p-${i + 1}`}></div>
                ))}
            </div>

            <div className="splash-content">
                <div className="splash-logo-container">
                    <div className="splash-glow"></div>
                    <img
                        src="/logo-emblem.webp"
                        alt="Kitabon Ki Dolat"
                        className="splash-book-icon"
                        width="96"
                        height="96"
                        decoding="async"
                    />
                </div>

                <div className="splash-text-group">
                    <div className="splash-urdu" lang="ur" dir="rtl">کتابوں کی دولت</div>
                    <div className="splash-english">KITABON KI DOLAT</div>
                </div>

                <div className="splash-loader" aria-hidden="true">
                    <div className="splash-loader-bar"></div>
                </div>
                
                <p className="splash-status">Opening your library...</p>
            </div>
        </div>
    );
}
